module.exports = __webpack_public_path__ + "img/green_014.6539eaa6.png";